<template>
  <div class="b-payment-details__terms">
    <div>
      <div class="custom-chck custom-chck--additional-style">
        <input id="contest" v-model="registerContest" type="checkbox" />
        <label for="contest">
          <span class="custom-chck__span">
            <div class="custom-chck__text">
              <span v-html="store.getContestText"></span>
            </div>
          </span>
        </label>
      </div>
    </div>
  </div>
</template>

<script>
import { useBookingStore } from './../../../store/BookingStore'

export default {
  props: {
    additionalPayload: {
      default() {
        return null
      },
      type: Object,
    },
  },
  setup() {
    return { store: useBookingStore()}
  },
  computed: {
    registerContest: {
      get: function () {
        return this.store.bookingProgress.paymentDetails.registerContest
      },
      set: function (value) {
        this.store.setPaymentField({ field: 'registerContest', value })
      },
    },
  }
}
</script>
